import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h4>Request Early Access to Get Started</h4>
      <h1 className="gradient__text">The possibilities are <br /> beyond your imagination</h1>
      <p>Eye-Hear, a groundbreaking eye-tracking technology, is meticulously crafted for seamless integration with a range of 3C devices—Computers, Communication, and Consumer electronics. Elevating the interaction between users and their devices, Eye-Hear brings unparalleled accessibility, efficiency, and convenience to a diverse array of technological experiences.</p>
      <h4>Request Early Access to Get Started</h4>
    </div>
  </div>
);

export default Possibility;